import React from 'react'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
// @src imports
import { LEGACY_SITE_URL } from 'src/app/api'
import { Icon, NavLink, ProfileAvatar, Transition } from 'src/chrome'
import { BottomNav, defaultItems } from 'src/chrome/BottomNav/BottomNav'
import suspenseBoundary from 'src/chrome/SuspenseBoundary/suspenseBoundaryHOC'
import { FlexColumn } from 'src/styled'
import { useAccount, useActions, useSelector, useState } from 'src/hooks'
// relative imports

import theme from 'src/chrome/styles/Chrome.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

const linkTitle: React.CSSProperties = {
  position: 'relative',
  top: 27,
  fontSize: 11,
  color: '#646464',
}

const SideBar: React.FC = () => {
  const account = useAccount()

  const { height, width } = useSelector(state => state.window)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const actions = useActions()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <nav className={theme.sideBar}>
      {width > 756 ? (
        height > 880 ? (
          <div className={theme.fullHeight}>
            <NavLink
              id="goto_catalog_btn"
              className="active"
              onClick={actions.openCatalog}
            >
              <Icon icon={'SOCLOGO'} size={32} />
              <span style={linkTitle}>Catalog</span>
            </NavLink>
            <NavLink
              id={'goto_campaigns_btn'}
              className="active"
              onClick={() => actions.openCampaigns()}
            >
              <Icon icon={'CLIPBOARD'} />
              <span style={linkTitle}>Campaigns</span>
            </NavLink>
            <NavLink
              id={'goto_contacts_btn'}
              className="active"
              onClick={actions.openRelationshipManager}
            >
              <Icon icon={'CONTACT'} />
              <span style={linkTitle}>Relationships</span>
            </NavLink>
            <NavLink
              id={'goto_gift_store_btn'}
              className="active"
              onClick={actions.openGiftStore}
            >
              <Icon icon={'TAG'} />
              <span style={linkTitle}>Gifts</span>
            </NavLink>
            <FlexColumn style={{ justifyContent: 'center', marginTop: 40 }}>
              <button
                id="avatar_btn"
                aria-controls="drop-down-menu"
                aria-haspopup="true"
                onClick={handleClick}
                style={{ border: 'none', background: 'none' }}
              >
                <ProfileAvatar
                  account={account}
                  size={32}
                  style={{
                    zIndex: 300,
                    fontSize: '1.8rem',
                    color: '#fff',
                    letterSpacing: 1,
                  }}
                  isEditable={false}
                />
              </button>
              <Menu
                id="drop-down-menu"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
                keepMounted={false}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem
                  id="goto_account_btn"
                  onClick={actions.openAccount}
                  style={{ fontSize: 'initial', padding: '3px 16px' }}
                >
                  <Text type="body">{`Account #${account.genealogyId}`}</Text>
                </MenuItem>
                {!account.isNewUser && (
                  <MenuItem
                    onClick={() =>
                      (window.location.href = `${LEGACY_SITE_URL}/main-menu/?access_token=${account.token}`)
                    }
                    style={{ fontSize: 'initial', padding: '3px 16px' }}
                  >
                    <Text type="body">{'Legacy Site'}</Text>
                  </MenuItem>
                )}
                <MenuItem
                  onClick={() =>
                    (window.location.href = `${LEGACY_SITE_URL}/resources/`)
                  }
                  style={{ fontSize: 'initial', padding: '3px 16px' }}
                >
                  <Text type="body">{'Resource Center'}</Text>
                </MenuItem>
                <MenuItem
                  id="logout_btn"
                  onClick={actions.logout}
                  style={{ fontSize: 'initial', padding: '3px 16px' }}
                >
                  <Text type="body">{'Logout'}</Text>
                </MenuItem>
              </Menu>
              <span
                style={{ ...linkTitle, textAlign: 'center', marginTop: -15 }}
              >
                Account
              </span>
            </FlexColumn>
          </div>
        ) : (
          <BottomNav items={defaultItems} isSidebarEnabled={true} />
        )
      ) : (
        <div className={theme.mobile}>
          <BottomNav items={defaultItems} />
        </div>
      )}
    </nav>
  )
}

export default suspenseBoundary({
  component: SideBar,
  unresolved: <Transition message={'Loading sidebar...'} />,
  failure: error => `Failed loading sidebar: ${error}`,
})
